import { render, staticRenderFns } from "./collapsible.vue?vue&type=template&id=eba15288&scoped=true&"
import script from "./collapsible.vue?vue&type=script&lang=js&"
export * from "./collapsible.vue?vue&type=script&lang=js&"
import style0 from "./collapsible.vue?vue&type=style&index=0&id=eba15288&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba15288",
  null
  
)

export default component.exports